import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge tailwind class strings with conflict resolution.
 * Standard shadcn/ui helper — `clsx` for conditional joining,
 * `twMerge` to dedupe and resolve conflicts (later classes win).
 *
 * Usage:
 *   <div className={cn('px-4 py-2', isActive && 'bg-primary', className)} />
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
